<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="">
          <div class="">
            <div
              v-if="messageLogs.docs && messageLogs.docs.length > 0"
              class="Polaris-IndexTable"
            >
              <div class="Polaris-IndexTable__IndexTableWrapper">
                <table class="Polaris-DataTable__Table">
                  <thead>
                    <tr class="hidden md:table-row">
                      <th
                        data-polaris-header-cell="true"
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                        scope="col"
                      >
                        Phone Number
                      </th>
                      <th
                        data-polaris-header-cell="true"
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                        scope="col"
                      >
                        Message Status
                      </th>
                      <th
                        data-polaris-header-cell="true"
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                        scope="col"
                      >
                        Date
                      </th>
                      <th
                        data-polaris-header-cell="true"
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                        scope="col"
                      >
                        WhatsApp message
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="grid grid-cols-2 grid-flow-row md:table-row"
                      v-for="log in messageLogs.docs"
                      :key="log.id"
                    >
                      <td
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                      >
                        {{ log.phoneNumber }}
                      </td>
                      <td
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                      >
                        {{ log.messageStatus }}
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                          v-if="log.channel === 'sms'"
                        >
                          sent as {{ log.channel }}
                        </span>
                      </td>
                      <td
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                      >
                        {{ log.createdAt | dateFilter }}
                      </td>
                      <td
                        class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop whitespace-pre-wrap break-all"
                      >
                        {{ log.body }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Pagination :page="messageLogs" @pageChanged="loadPage" />
              </div>
            </div>
            <div
              class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
              v-if="
                !isLoading && messageLogs.docs && messageLogs.docs.length === 0
              "
            >
              <div
                class="Polaris-ShadowBevel"
                style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
              >
                <div
                  class="Polaris-Box"
                  style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)"
                >
                  <h2 class="Polaris-Text--root Polaris-Text--bodyMd">
                    You don't have any message logs right now. We will be
                    listing them here as soon as we sent a message.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

import Pagination from "../../components/Common/Pagination";

export default {
  name: "MessageLogs",
  components: {
    Pagination
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  data() {
    return {
      messageLogs: {},
      isLoading: false
    };
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    loadPage(page) {
      this.isLoading = true;
      this.$store
        .dispatch("Marketing/getMessageLog", { page })
        .then(response => {
          this.messageLogs = response.logs;
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
